export const GET_VEHICLES = 'GetVehicles';
